import { getCharacterCount, limits } from "constants/post";

export const PLATFORM_MEDIA_CONFIG = {
  facebook: {
    totalMedia: 10,
    image: {
      formats: [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
        "image/heic",
      ],
      maxSizeMB: 30,
      minDimensions: { width: 320, height: 150 },
      maxDimensions: { width: 8000, height: 8000 },
      aspectRatios: ["1:3", "3.2:1"],
    },
    video: {
      formats: [
        "video/mp4",
        "video/quicktime",
        "video/x-msvideo",
        "video/x-matroska",
        "video/mpeg",
        "video/x-flv",
        "video/x-ms-wmv",
        "video/3gpp",
        "video/3gpp2",
        "video/mp2t",
        "video/x-m4v",
        "video/webm",
        "video/x-ms-asf",
        "video/dv",
      ],
      maxSizeMB: 4096,
      maxDurationSeconds: 14400,
      minResolution: { width: 320, height: 315 },
      aspectRatios: ["1:3", "3.2:1"],
    },
    reel: {
      video: {
        formats: ["video/mp4", "video/quicktime"],
        maxSizeMB: 4096,
        maxDurationSeconds: 90,
        minResolution: { width: 1080, height: 1920 },
        maxResolution: { width: 1080, height: 1920 },
        aspectRatios: ["9:16"],
      },
    },
    story: {
      image: {
        formats: ["image/jpeg", "image/png", "image/heic"],
        maxSizeMB: 8,
        minDimensions: { width: 1080, height: 1920 },
        aspectRatios: ["9:16", "4:5", "1:1", "16:9", "1.91:1"],
      },
      video: {
        formats: ["video/mp4"],
        maxSizeMB: 100,
        maxDurationSeconds: 60,
        minResolution: { width: 1080, height: 1920 },
        aspectRatios: ["9:16", "4:5", "1:1", "16:9", "1.91:1"],
      },
    },
  },

  instagram: {
    totalMedia: 10,
    image: {
      formats: ["image/jpeg", "image/png", "image/heic"],
      maxSizeMB: 8,
      minDimensions: { width: 320, height: 320 },
      maxDimensions: { width: 1440, height: 4320 },
      aspectRatios: ["9:16", "4:5", "1:1", "16:9", "1.91:1"],
      carouselConsistency: false,
    },
    video: {
      formats: ["video/mp4", "video/quicktime"],
      maxSizeMB: 1024,
      maxDurationSeconds: 900,
      minResolution: { width: 320, height: 320 },
      aspectRatios: ["9:16", "4:5", "1:1", "16:9", "1.91:1"],
    },
    reel: {
      video: {
        formats: ["video/mp4", "video/quicktime"],
        maxSizeMB: 1024,
        maxDurationSeconds: 900,
        minResolution: { width: 320, height: 320 },
        aspectRatios: ["9:16", "4:5", "1:1", "16:9", "1.91:1"],
      },
    },
    story: {
      image: {
        formats: ["image/jpeg", "image/png", "image/heic"],
        maxSizeMB: 8,
        minDimensions: { width: 1080, height: 1920 },
        aspectRatios: ["9:16", "4:5", "1:1", "16:9", "1.91:1"],
      },
      video: {
        formats: ["video/mp4", "video/quicktime"],
        maxSizeMB: 100,
        maxDurationSeconds: 60,
        minResolution: { width: 1080, height: 1920 },
        aspectRatios: ["9:16", "4:5", "1:1", "16:9", "1.91:1"],
      },
    },
  },

  twitter: {
    totalMedia: 4,
    image: {
      formats: [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
        "image/heic",
      ],
      maxSizeMB: 5,
      minDimensions: { width: 320, height: 320 },
      maxDimensions: { width: 8192, height: 8192 },
      aspectRatios: ["1:3", "3.2:1"],
    },
    video: {
      formats: ["video/mp4", "video/quicktime"],
      maxSizeMB: 512,
      maxDurationSeconds: 140,
      minResolution: { width: 320, height: 320 },
      aspectRatios: ["1:3", "3:1"],
    },
  },

  linkedin: {
    totalMedia: 10,
    image: {
      formats: ["image/jpeg", "image/png"],
      maxSizeMB: 5,
      minDimensions: { width: 360, height: 360 },
      aspectRatios: ["1:3", "3.2:1"],
    },
    video: {
      formats: [
        "video/mp4",
        "video/quicktime",
        "video/x-msvideo",
        "video/webm",
        "video/x-matroska",
        "video/x-ms-wmv",
        "video/mpeg",
        "video/vc1",
        "video/dv",
        "video/x-flv",
      ],
      maxSizeMB: 200,
      maxDurationSeconds: 600,
      minResolution: { width: 360, height: 360 },
      aspectRatios: ["1:3", "3.2:1"],
    },
  },

  tiktok: {
    totalMedia: 10,
    image: {
      formats: ["image/webp", "image/jpeg"],
      maxSizeMB: 20,
      minDimensions: { width: 360, height: 360 },
      aspectRatios: ["1:3", "3.2:1"],
    },
    video: {
      formats: ["video/mp4", "video/quicktime", "video/webm"],
      maxSizeMB: 1024,
      maxDurationSeconds: 600,
      minResolution: { width: 360, height: 360 },
      maxResolution: { width: 4096, height: 4096 },
    },
  },

  pinterest: {
    totalMedia: 5,
    image: {
      formats: ["image/jpeg", "image/png", "image/webp", "image/heic"],
      maxSizeMB: 20,
      minDimensions: { width: 1000, height: 1500 },
      aspectRatios: ["2:3", "1:1"],
    },
    video: {
      formats: ["video/mp4", "video/x-m4v", "video/quicktime"],
      maxSizeMB: 2048,
      maxDurationSeconds: 300,
      minResolution: { width: 600, height: 900 },
      aspectRatios: ["1:1", "1:2", "2:3", "3:4", "4:5", "9:16"],
    },
  },

  meta_threads: {
    totalMedia: 4,
    image: {
      formats: ["image/jpeg", "image/png", "image/webp", "image/heic"],
      maxSizeMB: 8,
      minDimensions: { width: 360, height: 360 },
      maxResolution: { width: 1920, height: 8000 },
      aspectRatios: ["0.01:1", "10:1"],
    },
    video: {
      formats: ["video/mp4", "video/quicktime"],
      maxSizeMB: 1024,
      maxDurationSeconds: 300,
      minResolution: { width: 360, height: 360 },
      maxResolution: { width: 1920, height: 8000 },
      aspectRatios: ["0.01:1", "10:1"],
    },
  },

  youtube: {
    totalMedia: 1,
    thumbnail: {
      formats: ["image/jpeg", "image/png"],
      minDimensions: { width: 1280, height: 720 },
    },
    video: {
      formats: [
        "video/mp4",
        "video/quicktime",
        "video/x-msvideo",
        "video/x-ms-wmv",
        "video/x-flv",
        "video/mpeg",
        "video/webm",
        "video/3gpp",
        "video/x-matroska",
        "video/mp2t",
        "video/x-m4v",
        "video/dnxhd",
        "video/x-prores",
        "video/x-cineform",
        "video/hevc",
      ],
      maxSizeMB: 131072,
      maxDurationSeconds: 28800,
    },
    shorts: {
      video: {
        formats: [
          "video/mp4",
          "video/quicktime",
          "video/x-msvideo",
          "video/x-ms-wmv",
          "video/x-flv",
          "video/mpeg",
          "video/webm",
          "video/3gpp",
          "video/x-matroska",
          "video/mp2t",
          "video/x-m4v",
          "video/dnxhd",
          "video/x-prores",
          "video/x-cineform",
          "video/hevc",
        ],
        maxSizeMB: 2048, // 2GB
        maxDurationSeconds: 180, // 3 minutes
        minResolution: { width: 360, height: 360 },
        aspectRatios: ["1:1", "4:5", "3:4", "2:3", "9:16"],
      },
    },
  },
};

const MEDIA_TYPE = {
  image: "image",
  video: "video",
};

const PLATFORM_SPECIFIC_VALIDATORS = {
  facebook: ({ mediaListRaw, postType, errors }) => {
    if (
      postType === "reel" &&
      mediaListRaw.filter((m) => m.type.includes(MEDIA_TYPE.video)).length !== 1
    ) {
      errors.push("Must be exactly one video to post a reel");
    }
  },

  instagram: ({ mediaListRaw, postType, errors }) => {
    if (!mediaListRaw.length && postType !== "reel") {
      errors.push("Include at least one media file");
    }
    if (postType === "story" && mediaListRaw.length > 1) {
      errors.push("You can only upload 1 media file for your story");
    }
    if (
      postType === "reel" &&
      mediaListRaw.filter(
        (m) => typeof m.type === "string" && m.type.includes(MEDIA_TYPE.video)
      ).length !== 1
    ) {
      errors.push("Must be exactly one video to post a reel");
    }
  },

  tiktok: ({ mediaListRaw, errors }) => {
    if (!mediaListRaw.length) errors.push("Include at least one media file");
  },

  youtube: ({ mediaListRaw, title, errors }) => {
    if (
      mediaListRaw.filter((m) => m.type.includes(MEDIA_TYPE.video)).length !== 1
    ) {
      errors.push("Must be exactly one video to post to YouTube");
    }
    if (!title) errors.push("Include a Video title");
    if (mediaListRaw.some((m) => m.type.includes(MEDIA_TYPE.image))) {
      errors.push("YouTube does not support posting images");
    }
  },

  pinterest: ({ mediaListRaw, title, errors }) => {
    if (!title) errors.push("Include a Pin title");
    if (mediaListRaw.length > 1)
      errors.push("You can only upload 1 media file");
  },

  twitter: ({ caption, errors }) => {
    if (/https?:\/\/\S+/i.test(caption ?? "")) {
      errors.push("Links cannot be included in X (Twitter) posts");
    }
  },

  meta_threads: ({ mediaListRaw, errors }) => {
    if (mediaListRaw.length > 1) errors.push("Maximum 1 media file per thread");
  },
};

export const validatePlatformContent = ({
  mediaListRaw = [],
  platform,
  postType = "post",
  caption = "",
  title = "",
  twitterCharLimit,
}) => {
  if (!Array.isArray(mediaListRaw) || !PLATFORM_MEDIA_CONFIG[platform])
    return { platformErrors: [], mediaList: mediaListRaw };

  const config = PLATFORM_MEDIA_CONFIG[platform];
  const errors = [];

  // Validate total media count
  if (mediaListRaw.length > config.totalMedia) {
    errors.push(
      `Maximum ${config.totalMedia} media files allowed for ${platform}`
    );
  }

  // Validate caption and titles
  let charLimit = limits[platform];
  if (platform === "twitter" && typeof twitterCharLimit === "number") {
    charLimit = twitterCharLimit;
  }

  if (charLimit) {
    if (typeof charLimit === "number") {
      if (getCharacterCount(caption) > charLimit) {
        errors.push(`Caption exceeds ${charLimit} character limit`);
      }
    } else if (typeof charLimit === "object") {
      if (charLimit.title && getCharacterCount(title) > charLimit.title) {
        errors.push(`Title exceeds ${charLimit.title} character limit`);
      }
      if (
        charLimit.description &&
        getCharacterCount(caption) > charLimit.description
      ) {
        errors.push(
          `Description exceeds ${charLimit.description} character limit`
        );
      }
      if (charLimit.content && getCharacterCount(caption) > charLimit.content) {
        errors.push(`Content exceeds ${charLimit.content} character limit`);
      }
    }
  }

  // Update media objects with individual errors
  const mediaList = mediaListRaw.map((media) => ({ ...media, errors: [] }));

  // media validations
  for (const [index, media] of mediaListRaw.entries()) {
    const { type, size, properties } = media;

    if (!properties) {
      // For now, don't attempt to validate files without the properties field set.
      // It is assumed that the user is on the editPost page or editing a duplicated post,
      // and the properties are missing for exisiting media (which have already passed validation during creation)
      continue;
    }

    let mediaType;
    if (typeof type === "string") {
      if (type.includes(MEDIA_TYPE.image)) {
        mediaType = MEDIA_TYPE.image;
      } else if (type.includes(MEDIA_TYPE.video)) {
        mediaType = MEDIA_TYPE.video;
      }
    }

    if (!mediaType) {
      const errorMsg = "Invalid file format or missing metadata";
      mediaList[index].errors.push(errorMsg);
      continue;
    }

    // Get appropriate config based on postType and mediaType
    const typeConfig = config[postType] || {};
    const mediaConfig = typeConfig[mediaType] || config[mediaType];

    if (!mediaConfig) {
      const errorMsg = `${postType} ${mediaType} not supported for ${platform}`;
      mediaList[index].errors.push(errorMsg);
      continue;
    }

    let carouselAspectRatio = null;
    if (mediaType === "image") {
      const { formats, maxSizeMB, minDimensions, maxDimensions, aspectRatios } =
        mediaConfig;

      if (!formats.includes(type) && type !== MEDIA_TYPE.image) {
        const errorMsg = `Unsupported image format. Allowed: ${formats.join(
          ", "
        )}`;
        mediaList[index].errors.push(errorMsg);
      }

      if (size > maxSizeMB) {
        const errorMsg = `Image exceeds ${maxSizeMB}MB limit`;
        mediaList[index].errors.push(errorMsg);
      }

      if (
        properties.width < minDimensions.width ||
        properties.height < minDimensions.height
      ) {
        const errorMsg = `Below minimum dimensions: ${minDimensions.width}x${minDimensions.height}`;
        mediaList[index].errors.push(errorMsg);
      }

      if (
        ["twitter", "meta_threads"].includes(platform) &&
        type === "image/gif" &&
        (media?.properties?.width > 1280 || media?.properties?.height > 1080)
      ) {
        const errorMsg =
          "GIF resolution is more than the maximum of 1280px by 1080px.";
        mediaList[index].errors.push(errorMsg);
      }

      // if (
      //   maxDimensions &&
      //   (properties.width > maxDimensions.width ||
      //     properties.height > maxDimensions.height)
      // ) {
      //   const errorMsg = `Exceeds maximum dimensions: ${maxDimensions.width}x${maxDimensions.height}`;
      //   mediaList[index].errors.push(errorMsg);
      // }

      if (aspectRatios) {
        const mediaAspect = properties.width / properties.height;
        const aspectValues = aspectRatios.map((ratio) => {
          const [w, h] = ratio.split(":");
          return w / h;
        });
        const [minAspect, maxAspect] = [
          Math.min(...aspectValues),
          Math.max(...aspectValues),
        ];

        if (mediaAspect < minAspect || mediaAspect > maxAspect) {
          const errorMsg = `Invalid aspect ratio. Allowed: ${aspectRatios.join(
            ", "
          )}`;
          mediaList[index].errors.push(errorMsg);
        }
      }

      if (mediaConfig.carouselConsistency && mediaListRaw.length > 1) {
        const currentAspect = (properties.width / properties.height).toFixed(2);
        if (index === 0) {
          carouselAspectRatio = currentAspect;
        } else if (currentAspect !== carouselAspectRatio) {
          const errorMsg =
            "All carousel images must maintain consistent aspect ratio";
          mediaList[index].errors.push(errorMsg);
        }
      }
    }

    if (mediaType === "video") {
      const {
        formats,
        maxSizeMB,
        maxDurationSeconds,
        minResolution,
        maxResolution,
        aspectRatios,
      } = mediaConfig;

      if (!formats.includes(type) && type !== MEDIA_TYPE.image) {
        const errorMsg = `Unsupported video format. Allowed: ${formats.join(
          ", "
        )}`;
        mediaList[index].errors.push(errorMsg);
      }

      if (size > maxSizeMB) {
        const errorMsg = `Video exceeds ${maxSizeMB}MB limit`;
        mediaList[index].errors.push(errorMsg);
      }

      if ((properties.duration ?? properties.length) > maxDurationSeconds) {
        const errorMsg = `Maximum duration: ${maxDurationSeconds} seconds`;
        mediaList[index].errors.push(errorMsg);
      }

      if (
        minResolution &&
        (properties.width < minResolution.width ||
          properties.height < minResolution.height)
      ) {
        const errorMsg = `Minimum resolution: ${minResolution.width}x${minResolution.height}`;
        mediaList[index].errors.push(errorMsg);
      }

      if (
        maxResolution &&
        (properties.width > maxResolution.width ||
          properties.height > maxResolution.height)
      ) {
        const errorMsg = `Maximum resolution: ${maxResolution.width}x${maxResolution.height}`;
        mediaList[index].errors.push(errorMsg);
      }

      if (platform === "youtube" && postType === "shorts") {
        if (properties.width > properties.height) {
          const errorMsg = "YouTube Shorts must be square or vertical";
          mediaList[index].errors.push(errorMsg);
        }
      } else if (aspectRatios) {
        const mediaAspect = properties.width / properties.height;
        const aspectValues = aspectRatios.map((ratio) => {
          const [w, h] = ratio.split(":");
          return w / h;
        });
        const [minAspect, maxAspect] = [
          Math.min(...aspectValues),
          Math.max(...aspectValues),
        ];

        if (mediaAspect < minAspect || mediaAspect > maxAspect) {
          const errorMsg = `Invalid aspect ratio. Allowed: ${aspectRatios.join(
            ", "
          )}`;
          mediaList[index].errors.push(errorMsg);
        }
      }
    }
  }

  // Platform-specific validations
  const platformValidator = PLATFORM_SPECIFIC_VALIDATORS[platform];
  if (platformValidator) {
    platformValidator({ mediaListRaw, postType, caption, title, errors });
  }

  // General platform requirements
  if (
    !["default", "instagram", "tiktok", "youtube"].includes(platform) &&
    !caption &&
    !mediaListRaw.length
  ) {
    errors.push("Include at least one media file or text");
  }

  const hasMultipleMediaFileTypes =
    mediaListRaw.some(
      (media) =>
        typeof media.type === "string" && media.type.includes(MEDIA_TYPE.image)
    ) &&
    mediaListRaw.some(
      (media) =>
        typeof media.type === "string" && media.type.includes(MEDIA_TYPE.video)
    );

  if (!["default", "youtube"].includes(platform) && hasMultipleMediaFileTypes) {
    errors.push("You can only upload 1 video or a set of pictures");
  }

  return { platformErrors: [...new Set(errors)], mediaList };
};

export const validateMediaBeforeUpload = (file, platform, postType) => {
  const tempErrors = [];
  const { type, size } = file;

  let mediaType;
  if (typeof type === "string") {
    if (type.includes(MEDIA_TYPE.image)) {
      mediaType = MEDIA_TYPE.image;
    } else if (type.includes(MEDIA_TYPE.video)) {
      mediaType = MEDIA_TYPE.video;
    }
  }

  const config = PLATFORM_MEDIA_CONFIG[platform];
  const typeConfig = config[postType] || {};
  const mediaConfig = typeConfig[mediaType] || config[mediaType];

  if (!mediaConfig) {
    tempErrors.push(`Unsupported media type for ${platform}`);
    return tempErrors;
  }

  if (!mediaConfig.formats.includes(type)) {
    tempErrors.push("Unsupported file format");
  }

  if (size > mediaConfig.maxSizeMB * 1e6) {
    tempErrors.push(`File size exceeds ${mediaConfig.maxSizeMB}MB limit`);
  }

  return tempErrors;
};
